import AuthService from "./AuthService";

export default function AuthHeader() {
  const token = AuthService.getCurrentToken();
  if (token && token.access_token) {
    return { Authorization: `Bearer ${token.access_token}` };
  }

  return {};
}
